// Edu Match App
import EduMatch from '@edu-match/EduMatch';
import { useSelector } from 'react-redux';
import { Routes, Route } from 'react-router-dom';

import { useFeatureFlags } from '@core/context/FeatureFlagsContext';
import { selectDcsDegrees } from '@core/reducers/dcsSlice';

import BestMatchExperienceContainer from '../best-match-experience';
import EduResults from '../eduResults/EduResults';
import JoV1EduResults from '../jo-v1/JoV1EduResults';

const EduMatchRouter = () => {
  // eslint-disable-next-line camelcase
  const dcsDegrees = useSelector(selectDcsDegrees);
  const flags = useFeatureFlags();

  const LegacyResultComponent =
    (dcsDegrees.includes("Associate's") ||
      dcsDegrees.includes("Bachelor's") ||
      // Test EDU Results page on Grad results page
      flags?.voyagerGradResultsPage === 'test') &&
    !flags?.cypressTest
      ? EduResults
      : EduMatch;

  const isBestMatchExperience = flags?.bestMatchExperience === 'test';

  let ResultsComponent = LegacyResultComponent;

  if (flags?.joV1) {
    ResultsComponent = JoV1EduResults;
  } else if (isBestMatchExperience) {
    ResultsComponent = BestMatchExperienceContainer;
  }

  return (
    <Routes>
      <Route
        path="/results"
        element={<ResultsComponent experience={isBestMatchExperience ? 'bme' : 'edu-results'} />}
      />
    </Routes>
  );
};
export default EduMatchRouter;
